import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CapacityPlanRunsQueryVariables = Types.Exact<{
  agencyId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type CapacityPlanRunsQuery = { __typename?: 'Query', capacityPlanRuns: Array<{ __typename?: 'CapacityPlanRunSummary', id: any, agencyId?: any | null, agencyName?: string | null, isNetworkRun: boolean, label?: string | null, createdBy?: string | null, createdAt: any, fileName?: string | null, status: Types.CapacityPlanRunStatus, computedAt?: any | null, driverCount?: number | null, error?: string | null, totalDeliveries: number, geocodedDeliveries: number, settings: { __typename?: 'CapacityPlanRunSettings', depotLatitude?: number | null, depotLongitude?: number | null, capacity?: number | null, shiftStart: string, shiftEnd: string, breaks: Array<{ __typename?: 'CapacityPlanBreak', windowStart: string, windowEnd: string, durationSeconds: number }> }, solveProgress: { __typename?: 'CapacityPlanSolveProgress', total: number, queued: number, computing: number, computed: number, failed: number } }> };


export const CapacityPlanRunsDocument = gql`
    query CapacityPlanRuns($agencyId: ID) {
  capacityPlanRuns(agencyId: $agencyId) {
    id
    agencyId
    agencyName
    isNetworkRun
    label
    createdBy
    createdAt
    fileName
    status
    computedAt
    driverCount
    error
    totalDeliveries
    geocodedDeliveries
    settings {
      depotLatitude
      depotLongitude
      capacity
      shiftStart
      shiftEnd
      breaks {
        windowStart
        windowEnd
        durationSeconds
      }
    }
    solveProgress {
      total
      queued
      computing
      computed
      failed
    }
  }
}
    `;

/**
 * __useCapacityPlanRunsQuery__
 *
 * To run a query within a React component, call `useCapacityPlanRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapacityPlanRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityPlanRunsQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useCapacityPlanRunsQuery(baseOptions?: Apollo.QueryHookOptions<CapacityPlanRunsQuery, CapacityPlanRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapacityPlanRunsQuery, CapacityPlanRunsQueryVariables>(CapacityPlanRunsDocument, options);
      }
export function useCapacityPlanRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapacityPlanRunsQuery, CapacityPlanRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapacityPlanRunsQuery, CapacityPlanRunsQueryVariables>(CapacityPlanRunsDocument, options);
        }
export type CapacityPlanRunsQueryHookResult = ReturnType<typeof useCapacityPlanRunsQuery>;
export type CapacityPlanRunsLazyQueryHookResult = ReturnType<typeof useCapacityPlanRunsLazyQuery>;
export type CapacityPlanRunsQueryResult = Apollo.QueryResult<CapacityPlanRunsQuery, CapacityPlanRunsQueryVariables>;